import { UserModelInDTO } from 'app/auth/store/type';
import { ROUTER_API } from 'app/constants/api.constant';
import BaseApi from 'app/services/api/base.api';

export const validationApiV2 = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 60000 });

export const acceptTermsApi = async () => {
  const response = await validationApiV2.api.patch<UserModelInDTO>(`api/v2/users/accept-terms`);
  return response.data;
};
